import green from '@material-ui/core/colors/green';

export const COLORS = {
  primary: {
    light: '#FF3B00',
    main: '#FF3B00',
    dark: '#FF3B00',
    contrastText: '#ffffff',
  },
  secondary: {
    light: green[300],
    main: green[500],
    dark: green[700],
  },
};

export const THUMBNAIL_SIZE = 80;
export const BASE_URL = process.env.REACT_APP_SMT_SERVER_URL;
export const AWS_BASE_URL = 'http://ec2-54-164-239-202.compute-1.amazonaws.com:4000';
export const AWS_AUTH_TOKEN = '37A8AB91-DE3A-4C31-B9AD-75A60C1A';
export const SMARTTONES_API_TOKEN = 'B287F0D4-410D-4DB8-8F31-3656BA3A8526';

export const ROLES = {
  SUPERADMIN: 'superadmin',
  ADMIN: 'admin',
  CMS: 'cms',
  USERS: 'users',
  KEYS: 'keys',
  TRIVIA: 'trivia',
  TEMPLATE: 'template',
  FLOW: 'flow',
  CHANNELADMIN: 'channelAdmin',
  CHANNELHOST: 'channelHost',
  DRAW: 'draw',
  SPORTRADAR: 'sportradar',
  PUSHNOTIFICATION: 'pushnotification',
  ANALYTICS: 'analytics',
  DEVELOPER: 'developer',
  IMAGELIBRARY: 'imageLibrary',
  PASSKITINFO: 'passKitInfo',
  AGENCY: 'agency',
  INFLUENCER: 'influencer',
  BCLC: 'bclc',
};

Object.freeze(ROLES);
